// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelForm-Error_cls1__Hp3Zv","cls2":"PaymentChannelForm-Error_cls2__afWFR PaymentChannelForm-Error_cls1__Hp3Zv"};